import { useState } from "react";
import { Flex, LoadingIndicator, Text, TextInput } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { SPACING } from "~/styles/variables";
import { HierarchyTreeGrid, type TypeHierarchy } from "./DataPackageSlideout/HierarchyTreeGrid";
import { ImportErrorsBanner, type RowError } from "./ImportErrorsBanner";
import * as styles from "./styles_vanilla.css";

export type HierarchyPreviewPaneProps = {
  isUploading: boolean;
  previewData: TypeHierarchy | null;
  rowErrors: RowError[];
  nodeCount: number;
  preSignedErrorReportUrl: string | null;
};

export const HierarchyPreviewPane = ({
  isUploading,
  previewData,
  rowErrors,
  nodeCount,
  preSignedErrorReportUrl,
}: HierarchyPreviewPaneProps) => {
  const [searchValue, setSearchValue] = useState("");

  return (
    <Flex flexDirection="column" flexGrow={1} className={styles.hierarchyContentPanel}>
      {isUploading ? (
        <Flex
          flexGrow={1}
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          gap={SPACING.SMALL}
        >
          <LoadingIndicator />
          <Text variant="secondary-md">Uploading and processing file...</Text>
        </Flex>
      ) : previewData ? (
        <Flex flexDirection="column" flexGrow={1} gap={SPACING.SMALL}>
          <ImportErrorsBanner
            rowErrors={rowErrors}
            nodeCount={nodeCount}
            preSignedErrorReportUrl={preSignedErrorReportUrl}
          />
          <Flex justifyContent="space-between" alignItems="center">
            <Text variant="h4">Hierarchy preview</Text>
            <TextInput
              data-testid="hierarchy-preview-search"
              placeholder="Search hierarchy"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              icon="search"
            />
          </Flex>
          <HierarchyTreeGrid typeHierarchy={previewData} searchValue={searchValue} />
        </Flex>
      ) : (
        <Flex
          flexGrow={1}
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          gap={SPACING.SMALL}
        >
          <Icon type="search" size="xxx-large" className={styles.previewIcon} />
          <Text variant="regular-md">Hierarchy preview</Text>
          <Text variant="secondary-md">Your hierarchy will appear here once uploaded</Text>
        </Flex>
      )}
    </Flex>
  );
};
